export const adModesRU = {
  Tag: {
    default: {
      scripts: ['GPT', 'Taboola'],
    },
  },
  Homepage: {
    default: {
      scripts: ['Yandex'],
    },
  },
  Category: {
    default: {
      scripts: ['GPT', 'Taboola'],
    },
  },
  Article: {
    default: {
      scripts: ['GPT', 'Taboola', 'Teads', 'FooterAd', 'Outstream'],
      options: { GPT: { withCriteo: true, stickyUnits: { desktop: ['masthead'] } } },
      ignoredAdUnits: {
        GPT: {
          desktop: ['bottomBranding'],
          mobile: ['bottomBranding'],
        },
      },
    },
  },
  Webview: {
    default: {
      scripts: ['GPT', 'Taboola'],
    },
  },
  Custom: {
    onlyGPT: {
      scripts: ['GPT'],
    },
  },
};
